"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _MediaViewer = _interopRequireDefault(require("./MediaViewer"));

var _MessageInfo = _interopRequireDefault(require("./MessageInfo"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  components: {
    MessageInfo: _MessageInfo.default,
    MediaViewer: _MediaViewer.default
  },
  props: ['ml', 'message', 'idx'],
  data: function data() {
    return {};
  },
  computed: {
    displayNick: function displayNick() {
      var suffix = this.message.nick ? ':' : '';
      return this.message.nick + suffix;
    },
    userColour: function userColour() {
      return this.ml.userColour(this.message.user);
    }
  },
  methods: {
    userMode: function userMode(user) {
      return this.ml.buffer.userMode(user);
    },
    userModePrefix: function userModePrefix(user) {
      return this.ml.buffer.userModePrefix(user);
    }
  }
};
exports.default = _default;